import React from 'react';

import { Label } from '@/components/ui/label';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

const LEAD_SOURCE_OPTIONS = [
  { value: 'Inbound Phone Call', label: 'Inbound Phone Call' },
  { value: 'Email - Facebook Lead', label: 'Email - Facebook Lead' },
  { value: 'Email - Webform', label: 'Email - Webform' },
  { value: 'Email - LSA', label: 'Email - LSA' },
  { value: 'Email - Attorney Provided', label: 'Email - Attorney Provided' },
  { value: 'Text', label: 'Text' },
] as const;

interface LeadSourceSelectProps {
  value: string;
  onChange: (value: string) => void;
  showError?: boolean;
}

export const LeadSourceSelect: React.FC<LeadSourceSelectProps> = ({
  value,
  onChange,
  showError = false,
}) => {
  const isEmpty = !value || value.trim() === '';
  const shouldShowError = showError && isEmpty;

  return (
    <div
      className={`bg-white rounded-lg shadow-sm p-3 border-2 transition-colors ${
        shouldShowError ? 'border-red-500 bg-red-50' : 'border-gray-200'
      }`}
    >
      <Label
        htmlFor="lead-source"
        className={`text-sm font-semibold mb-2 block ${
          shouldShowError ? 'text-red-700' : 'text-gray-900'
        }`}
      >
        Lead Source {shouldShowError && <span className="text-red-600">*</span>}
      </Label>
      <Select value={value} onValueChange={onChange}>
        <SelectTrigger
          id="lead-source"
          className={`w-full ${
            shouldShowError ? 'border-red-500 focus:ring-red-500' : ''
          }`}
        >
          <SelectValue placeholder="Select lead source" />
        </SelectTrigger>
        <SelectContent>
          {LEAD_SOURCE_OPTIONS.map((option) => (
            <SelectItem key={option.value} value={option.value}>
              {option.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {shouldShowError && (
        <p className="text-xs text-red-600 mt-2 font-medium">
          Lead Source is required to create a matter
        </p>
      )}
    </div>
  );
};

export default LeadSourceSelect;
